<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.33301 10.6667C4.59663 10.6667 3.99967 11.2636 3.99967 12V26.6667C3.99967 27.403 4.59663 28 5.33301 28H26.6663C27.4027 28 27.9997 27.403 27.9997 26.6667V12C27.9997 11.2636 
                27.4027 10.6667 26.6663 10.6667H5.33301ZM1.33301 12C1.33301 9.79086 3.12387 8 5.33301 8H26.6663C28.8755 8 30.6663 9.79086 30.6663 12V26.6667C30.6663 28.8758 28.8755 30.6667 
                26.6663 30.6667H5.33301C3.12387 30.6667 1.33301 28.8758 1.33301 26.6667V12Z"
            fill="white"
            fill-opacity="0.87"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.39052 1.72353C8.91122 1.20283 9.75544 1.20283 10.2761 1.72353L16 7.44739L21.7239 1.72353C22.2446 1.20283 23.0888 1.20283 23.6095 1.72353C24.1302 2.24423 24.1302 3.08845 
                23.6095 3.60915L16.9428 10.2758C16.4221 10.7965 15.5779 10.7965 15.0572 10.2758L8.39052 3.60915C7.86983 3.08845 7.86983 2.24423 8.39052 1.72353Z"
            fill="white"
            fill-opacity="0.87"
        />
    </svg>

</template>